import { render } from "./page-berita.vue?vue&type=template&id=296a182b&scoped=true"
import script from "./page-berita.vue?vue&type=script&lang=js"
export * from "./page-berita.vue?vue&type=script&lang=js"

import "./page-berita.vue?vue&type=style&index=0&id=296a182b&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296a182b"]])

export default __exports__